(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lcw-pdp-sabores"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = () => {
      document.querySelectorAll('[data-sabores]:not(.js-sabores)').forEach((secao) => {
        const textos = [...secao.querySelectorAll('.lcw-sab__texto')];
        const fotos = [...secao.querySelectorAll('.lcw-sab__foto')];
        const nav = secao.querySelector('[data-sabor-nav]');
        const contador = secao.querySelector('[data-sabor-contador]');
        if (textos.length < 2 || !nav) return;
        secao.classList.add('js-sabores');
        nav.hidden = false;
        const chips = [...secao.querySelectorAll('[data-sabor-chip]')];
        const fundos = [...secao.querySelectorAll('[data-sabor-fundo]')];
        const caixaChips = secao.querySelector('[data-sabor-chips]');
        if (caixaChips) caixaChips.hidden = false;
        chips.forEach((c) => c.addEventListener('click', () => mostrar(Number(c.dataset.saborChip))));
        let atual = 0;
        const mostrar = (i) => {
          atual = (i + textos.length) % textos.length;
          textos.forEach((t, k) => { t.hidden = k !== atual; });
          fotos.forEach((f) => { f.hidden = Number(f.dataset.sabor) !== atual; });
          fundos.forEach((f) => { f.hidden = Number(f.dataset.saborFundo) !== atual; });
          secao.classList.toggle('tem-fundo', fundos.some((f) => !f.hidden));
          if (contador) contador.textContent = `${atual + 1} de ${textos.length}`;
          chips.forEach((c, k) => c.setAttribute('aria-pressed', k === atual ? 'true' : 'false'));
          // avisa o sachê 3D (se estiver ligado) para trocar a estampa
          secao.dataset.saborAtual = atual;
          secao.dispatchEvent(new CustomEvent('lcw:sabor', { detail: { indice: atual } }));
        };
        secao.querySelector('[data-sabor-anterior]').addEventListener('click', () => mostrar(atual - 1));
        secao.querySelector('[data-sabor-proximo]').addEventListener('click', () => mostrar(atual + 1));
        // No editor: selecionar um bloco mostra aquele sabor
        secao.addEventListener('shopify:block:select', (e) => {
          const i = textos.indexOf(e.target.closest('.lcw-sab__texto'));
          if (i >= 0) mostrar(i);
        });
        mostrar(0);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcw-pdp-split"] && !Shopify.designMode) return;
  try {
    
  /*
    Entrada do gráfico de barras, em etapas (tempos no lcw-pdp.css):
    grade se desenha → barras crescem uma após a outra → valores contam
    de 0 até o número → linha tracejada atravessa → destaque aparece.

    Só roda com JavaScript e sem "reduzir movimento". Sem isso o HTML
    já traz o gráfico pronto, com os números finais.
  */
  (() => {
    const formatar = (n, casas) => n.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });

    // Conta de 0 até o valor, desacelerando no fim, junto com a barra.
    const contar = (el, atraso) => {
      const alvo = parseFloat(el.dataset.valor);
      const casas = parseInt(el.dataset.casas, 10) || 0;
      const unidade = el.dataset.unidade ? ' ' + el.dataset.unidade : '';
      if (!Number.isFinite(alvo)) return;
      const duracao = 900;
      el.textContent = formatar(0, casas) + unidade;
      setTimeout(() => {
        const inicio = performance.now();
        const passo = (agora) => {
          const t = Math.min(1, (agora - inicio) / duracao);
          const suave = 1 - Math.pow(1 - t, 3);
          el.textContent = formatar(alvo * suave, casas) + unidade;
          if (t < 1) requestAnimationFrame(passo);
        };
        requestAnimationFrame(passo);
      }, atraso);
    };

    const tocar = (grafico) => {
      grafico.classList.remove('is-visivel');
      void grafico.offsetWidth; // reinicia as transições (útil no editor)
      grafico.classList.add('is-visivel');
      grafico.querySelectorAll('[data-valor]').forEach((el) => {
        const i = parseInt(getComputedStyle(el.closest('.lcw-grafico__coluna')).getPropertyValue('--i'), 10) || 0;
        contar(el, 350 + i * 250);
      });
    };

    const iniciar = () => {
      const graficos = document.querySelectorAll('[data-grafico]:not(.js-anima)');
      if (!graficos.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      const observador = new IntersectionObserver((entradas) => {
        entradas.forEach((entrada) => {
          if (!entrada.isIntersecting) return;
          tocar(entrada.target);
          observador.unobserve(entrada.target);
        });
      }, { threshold: 0.25 });
      graficos.forEach((g) => { g.classList.add('js-anima'); observador.observe(g); });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
    // Painel com abas: setas do teclado navegam, e trocar de aba toca a
    // entrada do gráfico que aparece.
    const iniciarAbas = () => {
      document.querySelectorAll('[data-abas]:not(.js-abas)').forEach((painel) => {
        painel.classList.add('js-abas');
        const abas = [...painel.querySelectorAll('[role="tab"]')];
        const ativar = (aba, foco) => {
          abas.forEach((a) => {
            const sel = a === aba;
            a.setAttribute('aria-selected', sel ? 'true' : 'false');
            a.tabIndex = sel ? 0 : -1;
            document.getElementById(a.getAttribute('aria-controls')).hidden = !sel;
          });
          if (foco) aba.focus();
          const g = document.getElementById(aba.getAttribute('aria-controls')).querySelector('[data-grafico]');
          if (g && g.classList.contains('js-anima')) tocar(g);
        };
        abas.forEach((aba, i) => {
          aba.addEventListener('click', () => ativar(aba, false));
          aba.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            ativar(abas[(i + (e.key === 'ArrowRight' ? 1 : -1) + abas.length) % abas.length], true);
          });
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarAbas);
    else iniciarAbas();
    document.addEventListener('shopify:section:load', iniciarAbas);

    // No editor: clicar no bloco do gráfico toca a animação de novo.
    document.addEventListener('shopify:block:select', (e) => {
      const g = e.target.closest && e.target.closest('[data-grafico]');
      if (g && g.classList.contains('js-anima')) tocar(g);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
